var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('title')))]),_c('h2',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.$t('subtitle')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }